import { post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api';
// const eNotifyPath = `${url}/mNotifyPromo`;

// 0. 登入
export function postSSOInput(data) {
    return post(`${url}/ssoTest/sso_main`, data, { ...options, closeAlert: true });
}
